<template>
   <div>
      <!-- PARTIE TACHES  -->
      <div class="container-mobile sous-titre" style="margin-top:32px">Tâches à prévoir</div>
      <div class="spinner-container" v-if="loading">
         <BeatLoader color="#1389EF" />
      </div>
      <div v-else>
         <div class="text-center" v-if="taches.length == 0">Vous êtes à jour !</div>
         <div class="liste" style="margin-bottom:80px">
            <div v-for="tache in taches" :key="tache.id" class="liste-item" @click="validerTache(tache.id)">
               <div class="flex">
                  <div>{{ tache.nom }}</div>
               </div>

               <div class="liste-icones">
                  <div>
                     <b-icon icon="check" type="is-success"></b-icon>
                  </div>
               </div>
            </div>
         </div>
         <!-- fin table -->
      </div>
   </div>
</template>

<script>
import axios from 'axios';
import { BeatLoader } from '@saeris/vue-spinners';

export default {
   components: {
      BeatLoader
   },
   data() {
      return {
         loading: true,
         taches: []
      };
   },
   mounted() {
      this.getTaches();
   },
   methods: {
      async getTaches() {
         this.loading = true;
         let res = await axios.get('/ruches/' + this.$route.params.id + '/taches');
         this.taches = res.data;
         this.loading = false;
      },
      async validerTache(id) {
         this.$buefy.dialog.confirm({
            message: 'Souhaitez-vous vraiment marquer cette tâche comme faite ?',
            cancelText: 'Non',
            title: 'Confirmation',
            hasIcon: true,
            confirmText: 'Oui',
            type: 'is-success',
            onConfirm: () => {
               axios.delete('/taches/' + id).then(res => {
                  if (res.data.erreur) {
                     this.$buefy.toast.open({
                        message: res.data.erreur,
                        type: 'is-danger'
                     });
                  } else {
                     this.$buefy.toast.open({
                        message: 'Tâche validée !',
                        type: 'is-success'
                     });
                     this.taches = this.taches.filter(tache => tache.id != id);
                  }
               });
            }
         });
      }
   }
};
</script>
